/**
 * Stock Health colouring shared by the Stock Planning grid and the Create
 * Call-Off warehouse grid (CR-7717): a negative Stock Health Min or Max is a
 * deficit, so its value is shown in red in both.
 */

/** The two Stock Health columns. */
export const STOCK_HEALTH_COLUMNS: ReadonlyArray<string> = ['stock_health_min', 'stock_health_max'];

/**
 * Whether a cell is a Stock Health value below zero.
 *
 * @param columnId - the grid column id
 * @param value - the cell's raw value (number or numeric string)
 * @returns true only for a Stock Health column holding a negative number
 */
export function isNegativeStockHealth(columnId: string, value: unknown): boolean {
  if (STOCK_HEALTH_COLUMNS.indexOf(columnId) === -1) return false;
  const num = parseFloat(String(value ?? ''));
  return !isNaN(num) && num < 0;
}
